module.exports = __webpack_public_path__ + "static/media/pv.c25a0e38.webp";